export default __webpack_public_path__ + "static/media/blog.677b2552.jpg";